import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCustomer } from "../api/customer";
import { DeleteMobility } from "../types/types";
import { useSnackbar } from "notistack";

const useDeleteCustomer = (
  { seq }: DeleteMobility,
  closeModal: () => void
) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: () => deleteCustomer({ seq }),

    onSuccess: () => {
      // console.log(data);
      queryClient.invalidateQueries({ queryKey: ["Customer"] });
      enqueueSnackbar(`소유자 삭제 성공`, {
        variant: "success",
      });
      closeModal();
    },
  });
  return mutation;
};

export default useDeleteCustomer;
